import z from "zod";
//
// Entity
//
export const DTOLoginScreenSettings = z.object({
    isEnabled: z.boolean(), // Flag to enable/disable the login screen
    title: z.string().optional(),
    color: z.string().optional(),
    logoUrl: z.string().optional(),
    isGoogleEnabled: z.boolean(), // Flag for Google login
    isEmailEnabled: z.boolean(), // Flag for email login
    isSsoEnabled: z.boolean(), // Flag for SSO login
});
//
// Payloads
//
export const DTOLoginScreenSettingsUpdate = DTOLoginScreenSettings.extend({
    logoFileId: z.string().nullish(),
    title: z
        .string()
        .max(160, "Custom Login page title is too long. Maximum length is 160 characters.")
        .nullish(),
    color: z
        .string()
        .refine((val) => val === null ||
        /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(val), "Must be a valid hex color (e.g. #FF0000 or #FF000080) or null")
        .nullish(),
})
    .omit({ logoUrl: true })
    .partial();
export const DTOLoginScreenSettingsResponse = z.object({
    loginScreenSettings: DTOLoginScreenSettings,
});
